module.exports = __webpack_public_path__ + "img/34.7b47a1ae.jpg";